const CORE_GROUP = 'core';

// Empty tracking groups = null = every group fires. A configured list gates
// PostHog to those groups, always including the shared `core` group so page
// view and time-on-page keep firing.
const resolveEnabledGroups = (trackingGroups) => {
  if (!trackingGroups) return null;

  const groups = trackingGroups.split(',').map(group => group.trim()).filter(Boolean);

  return [...groups, CORE_GROUP];
};

export default resolveEnabledGroups;
